<template>
  <div>
    <section class="related-artists" v-if="relatedArtists.length">
      <h2>Related Artists</h2>

      <div class="headshots-container">
        <ul class="headshots">
          <Headshot v-for="artist in relatedArtists" :key="artist.id" :item="artist" :image="(artist.artwork ? artist.artwork[0].images[0].image.url : artist.headshot.url)" :name="artist.name"></Headshot>
        </ul>
      </div>
    </section>

    <section class="related-events" v-if="relatedEvents.length">
      <h2>Related Events</h2>

      <div class="events-grid list-container">
        <div v-for="event in relatedEvents" :key="event.id" class="event">
          <div class="event-content">
            <span class="event-stats">{{event.category}} &bull; {{event.event_type === 'Other' ? event.event_type_other : event.event_type}}</span>

            <img v-if="event.featured_images" :src="event.featured_images[0].image.url" :alt="event.featured_images[0].image.alt">

            <span class="event-name">{{event.program_title}}</span>
            <span class="artist-name">{{event.artist_name}}</span>

            <span class="event-date">{{event.date}} {{event.time}}</span>

            <a :href="`http://maps.google.com/?q=` + encodeURIComponent(`${event.address} ${event.city} ${event.state} ${event.zip}`)" class="tour-address" target="_blank">{{event.address}} {{event.address_2}} {{event.city}} {{event.zip}}</a>

            <p>{{event.description}}</p>

            <a v-if="event.additional_links && event.additional_links.indexOf('http') > -1" :href="event.additional_links" class="btn" target="_blank">Additional Resources</a>
            <a v-if="event.location_rsvp && event.location_rsvp.indexOf('http') > -1" :href="event.location_rsvp" class="btn" target="_blank">RSVP</a>

            <span class="location-details"><template v-if="event.location_type">{{event.location_type}}</template><template v-if="event.location_experience.length"><span v-for="exp in event.location_experience" :key="exp"> &bull; {{exp}}</span></template></span>
          </div>
        </div>
      </div>
    </section>

    <section class="related-partners" v-if="relatedPartners.length">
      <h2>Related Partners</h2>

      <div class="bp-grid list-container" v-if="relatedPartners.length">
        <a :href="`/#/${$route.name}/${partner.id}`" v-for="partner in relatedPartners" :key="partner.id" class="bp" @click="$router.push(`/#/${$route.name}/${partner.id}`)">
          <div class="bp-content">
            <span v-if="partner.tour_side && partner.tour_side !== 'Unassigned'" class="tour-side">{{partner.tour_side}}</span>
            <img v-if="partner.featured_image" :src="partner.featured_image.url" :alt="partner.featured_image.alt">

            <span class="bp-name"><template v-if="partner.tour_number">{{partner.tour_number}}. </template>{{partner.business_name}}</span>
            <div class="partner-location">
              <span class="tour-address">{{partner.tour_address}} {{partner.tour_address_2}}<br> {{partner.tour_city}} {{partner.tour_zip}}</span>
            </div>
          </div>
        </a>
      </div>
    </section>
  </div>
</template>

<script>
import Headshot from "./Headshot";

export default {
  components: { Headshot },
  props: ['item'],
  data() {
    return {
      relatedArtists: [],
      relatedEvents: [],
      relatedPartners: [],
    }
  },
  mounted() {
    // Artists
    this.relatedArtists.splice(0, this.relatedArtists.length);

    const artists = [];
    const relatedArtists = this.item.related.filter(item => item.post_type.includes(`participants-${this.$root.year}`));

    relatedArtists.forEach(async artist => {
      const response = await fetch(`${this.$root.api_url}getParticipants?id=${artist.ID}&year=${this.$root.year}`);
      let data = await response.json();
      artists.push(...data);
      this.relatedArtists.push(...artists);
    });

    // Events
    this.relatedEvents.splice(0, this.relatedEvents.length);

    const events = [];
    const relatedEvents = this.item.related.filter(item => item.post_type === `events-${this.$root.year}`);

    relatedEvents.forEach(async event => {
      const response = await fetch(`${this.$root.api_url}getEvents?year=${this.$root.year}&id=${event.ID}`);
      let data = await response.json();
      events.push(...data);
      this.relatedEvents.push(...events);
    });

    // Partners
    this.relatedPartners.splice(0, this.relatedPartners.length);

    const partners = [];
    const relatedPartners = this.item.related.filter(item => item.post_type === `bp-${this.$root.year}`);

    relatedPartners.forEach(async partner => {
      const response = await fetch(`${this.$root.api_url}getPartners?id=${partner.ID}`);
      let data = await response.json();
      partners.push(...data);
      this.relatedPartners.push(...partners);
    });
  },
};
</script>

<style scoped lang="less">
@import '../css/variables';

.related-artists {
  & + .related-events {
    margin-top: 50px;
  }
}

.related-events {
  margin-top: 50px;
}

.related-partners {
  margin-top: 50px;
  .bp-grid {
    @grid-layout-gap: 50px;
    @grid-column-count: 3;
    @grid-item--min-width: 300px;

    @gap-count: calc(@grid-column-count - 1);
    @total-gap-width: calc(@gap-count * @grid-layout-gap);
    @grid-item--max-width: calc(100% - (@total-gap-width) / @grid-column-count);

    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(max(@grid-item--min-width, @grid-item--max-width), 1fr));
    grid-gap: (@grid-layout-gap);
    .bp {
      text-decoration: none;
      &:hover {
        .bp-content .bp-name {
          color: @themeColor1;
        }
      }

      .bp-content {
        img {
          margin-bottom: 10px;
          max-width: 100%;
          height: 200px;
          object-fit: contain;
        }
        span,
        p,
        a {
          display: block;
          margin-bottom: 8px;
          color: #000;
          text-decoration: none;
        }
        p {
          margin-bottom: 20px;
        }
        .tour-side {
          font-weight: bold;
        }
        .bp-name {
          display: block;
          margin-bottom: 5px;
          font-family: @fontSecondary;
          font-weight: bold;
          font-size: 24px;
          color: #000;
        }
        .partner-location {
          span {
            display: block;
          }
          a {
            color: #000;
            text-decoration: none;
            &:hover {
              text-decoration: underline;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Related.vue